import { useState, useEffect, useRef } from 'react'

import Form from 'react-bootstrap/Form'
import Modal from 'react-bootstrap/Modal'
import InputGroup from "react-bootstrap/InputGroup"
import { RgbaColorPicker } from "react-colorful"
import Button from 'react-bootstrap/Button'

import { LiaPepperHotSolid } from "react-icons/lia";

import { SettingsGroup, Control } from './General'
import ScalarBox from "../../SpiceUI/ScalarBox"


import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';

import CustomSelect from '../../../Components/Form/CustomSelect'
import ColorPicker from './ColorPicker'

import * as Basic from './BasicFields'

export default function FontModule(props) {
    const font = props.font
    const setFont = props.setFont
    const selected = props.selected

    const [fontFace, setFontFace] = useState(null)
    const [fontHeight, setFontHeight] = useState(null)
    const [fontStyle, setFontStyle] = useState(null)
    const [textAlignment, setTextAlignment] = useState(null)
    const [color, setColor] = useState(null)

    const loaded = useRef(false)

    const reload = () => {
        if (font == null) {
            return
        }

        setFontFace((font.font_face) ? font.font_face : "Arial")
        setFontHeight((font.font_height) ? font.font_height : 20)
        setFontStyle((font.font_style) ? font.font_style : 'normal')
        setTextAlignment((font.text_alignment) ? font.text_alignment : 'center')
        setColor((font.color) ? font.color : { r: 0, g: 0, b: 0, a: 1 })

        loaded.current = true
    }

    useEffect(() => {
        loaded.current = false
    }, [selected])

    useEffect(() => {
        if (loaded.current) {
            return
        }

        reload()
    }, [font])

    useEffect(() => {

        if (fontFace == null || fontHeight == null || fontStyle == null || textAlignment == null || color == null) {
            return
        }

        let f = {}
        f.font_face = fontFace
        f.font_height = fontHeight
        f.font_style = fontStyle
        f.text_alignment = textAlignment
        f.color = color

        setFont(f)

    }, [fontFace, fontHeight, fontStyle, textAlignment, color])

    if (fontFace == null || fontHeight == null || fontStyle == null || textAlignment == null || color == null) {
        return (<></>)
    }

    return (
        <SettingsGroup name="Font">
            <Basic.SelectInput name="Font face"
                               value={fontFace}
                               setValue={setFontFace}
                               options={[
                                    { label: "Arial", value: "Arial" },
                                    { label: "Times New Roman", value: "Times New Roman" },
                                    { label: "Comic Sans MS", value: "Comic Sans MS" },
                                    { label: "a Asian Hiro", value: "a Asian Hiro" },
                                    { label: "Kashima Demo", value: "Kashima Demo" },
                                    { label: "Sans serif", value:"sans-serif"}
                               ]}
            />
            <Basic.SelectInput name="Font style"
                               value={fontStyle}
                               setValue={setFontStyle}
                               options={[
                                    { label: "Normal", value: "normal" },
                                    { label: "Bold", value: "bold" }
                                ]}
            />
            <Basic.PositiveIntegerInput name="Font size"
                                        value={fontHeight}
                                        setValue={setFontHeight}
            />
            <Basic.ColorInput name="Color"
                              value={color}
                              setValue={setColor}
            />
            <Basic.SelectInput name="Alignment"
                               value={textAlignment}
                               setValue={setTextAlignment}
                               options={[
                                    { label: "Left", value: "left" },
                                    { label: "Center", value: "center" },
                                    { label: "Right", value: "right" }
                                ]}
            />
        </SettingsGroup>
    )
}

